import React, { useState } from 'react';
import { AccordionItem } from './Accordion';
import { Check } from 'lucide-react';
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const tomos = [{
    num: '1',
    icon: '🎸',
    title: 'Primeros Pasos',
    quote: 'Antes de tocar una nota, hay que entender el instrumento que tenés en las manos.',
    items: ['Partes de la guitarra y cómo cuidarla', 'Cómo afinar paso a paso (con y sin afinador)', 'Postura correcta sentado y de pie', 'Cómo leer diagramas de acordes y tablaturas', 'Errores más comunes del día 1 y cómo evitarlos']
  }, {
    num: '2',
    icon: '✋',
    title: 'Acordes Base',
    quote: 'El 80% de las canciones que conocés se tocan con menos de 10 acordes.',
    items: ['Los 8 acordes esenciales, con diagrama y digitación', 'Ejercicios de cambio de acordes sin trabarte', 'Cómo colocar los dedos sin lastimarte', 'Rutina de calentamiento antes de practicar']
  }, {
    num: '3',
    icon: '🎵',
    title: 'Ritmo y Rasgueo',
    quote: 'Sin ritmo, hasta el acorde perfecto suena mal.',
    items: ['Patrones de rasgueo básicos (folklore, pop, reggae)', 'Cómo llevar el compás sin metrónomo', 'Ejercicios progresivos de mano derecha', 'Combinación de acordes + ritmo en tiempo real']
  }, {
    num: '4',
    icon: '🎤',
    title: 'Primeras Canciones',
    quote: 'Acá es donde todo lo anterior se convierte en música de verdad.',
    items: ['15 canciones fáciles de 2 a 3 acordes', 'Versiones simplificadas de temas conocidos en Argentina', 'Cómo seguir una canción nueva por tu cuenta', 'Checklist de progreso por canción']
  }, {
    num: '5',
    icon: '🖐️',
    title: 'Técnica y Digitación',
    quote: 'La diferencia entre tocar y tocar bien está en los detalles.',
    items: ['Ejercicios de independencia de dedos', 'Transiciones más rápidas entre acordes', 'Introducción a los primeros punteos simples', 'Cómo practicar sin generar malos hábitos']
  }, {
    num: '6',
    icon: '⭐',
    title: 'Tu Repertorio y Próximos Pasos',
    quote: 'El cierre del método: de principiante a alguien que toca de verdad.',
    items: ['Cómo armar tu propio repertorio de canciones', 'Rutina de práctica sostenida en el tiempo', 'Cómo seguir aprendiendo después del método', 'Hoja de ruta hacia el siguiente nivel']
  }];
  return <section id="tomos" className="w-full bg-fondo-principal text-white py-section px-4" data-id="element-183">
      <div className="text-center mb-8" data-id="element-184">
        <div className="inline-block bg-white/10 text-dorado-detalles text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-185">
          📦 Sistema Completo
        </div>
        <h2 className="text-2xl font-bold mb-2" data-id="element-186">
          6 tomos. De cero a tu primera canción.
        </h2>
        <p className="text-gray-300" data-id="element-187">Un método, un orden, sin saltos.</p>
      </div>

      <div className="mb-8" data-id="element-188">
        {tomos.map((tomo, idx) => <AccordionItem key={idx} variant="dark" isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)} title={<div className="flex items-center gap-3" data-id="element-190">
                <span className="text-dorado-detalles font-bold text-lg w-6" data-id="element-191">
                  {tomo.num}
                </span>
                <span className="text-xl" data-id="element-192">{tomo.icon}</span>
                <span className="font-bold text-base" data-id="element-193">{tomo.title}</span>
              </div>} content={<div className="pt-2" data-id="element-194">
                <p className="italic text-gray-300 mb-4 text-sm" data-id="element-195">
                  "{tomo.quote}"
                </p>
                <ul className="space-y-3" data-id="element-196">
                  {tomo.items.map((item, iIdx) => <li key={iIdx} className="flex items-start gap-2 text-sm" data-id="element-197">
                      <Check className="w-4 h-4 text-botones-acentos shrink-0 mt-0.5" data-id="element-198" />
                      <span data-id="element-199">{item}</span>
                    </li>)}
                </ul>
              </div>} data-id="element-189" />)}
      </div>

      <div className="bg-[#24180d] border border-white/10 rounded-xl p-6" data-id="element-200">
        <h3 className="font-bold mb-4 text-dorado-detalles" data-id="element-201">
          Cada tomo incluye:
        </h3>
        <ul className="space-y-3" data-id="element-202">
          {['Diagramas claros de cada acorde y ejercicio', 'Explicación en lenguaje simple, sin tecnicismos', 'Ejercicios de práctica progresivos', 'Checklist de autoevaluación', 'Pensado para aprender solo, sin profesor'].map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm" data-id="element-203">
              <Check className="w-4 h-4 text-botones-acentos shrink-0 mt-0.5" data-id="element-204" />
              <span className="text-gray-200" data-id="element-205">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}